import { createAsyncThunk } from '@reduxjs/toolkit';

import { authGet } from '../../utils/request';

const printWrLabel = createAsyncThunk('printer/printWrLabel',
  async ({ id }, { rejectWithValue }) => {
    try {
      return await authGet(`/printer/print/wrLabel/${id}`);
    } catch (error) {
      return rejectWithValue(`${error?.message} ${error?.info || ''}`);
    }
  });

export default printWrLabel;
